import { useState, useEffect } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Plus, QrCode, Download, Trash2 } from 'lucide-react';
import { api } from '../../contexts/AuthContext';
import { toast } from 'sonner';


export default function TablesPage() {
  const [tables, setTables] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ number: '', seats: 4 });
  const [qrDialog, setQrDialog] = useState(null);

  const load = () => { api.get(`/tables`).then(r => setTables(r.data)).catch(() => {}); };
  useEffect(load, []);

  const create = async () => {
    try {
      await api.post(`/tables`, { number: parseInt(form.number), seats: parseInt(form.seats), active: true });
      toast.success('Table creee'); setShowForm(false); setForm({ number: '', seats: 4 }); load();
    } catch { toast.error('Erreur'); }
  };

  const del = async (id) => {
    if (!window.confirm('Supprimer cette table ?')) return;
    await api.delete(`/tables/${id}`);
    toast.success('Supprimee'); load();
  };

  const showQR = async (table) => {
    try {
      const { data } = await api.get(`/tables/${table.id}/qrcode`);
      setQrDialog(data);
    } catch (error) {
      toast.error(error?.response?.data?.detail || 'Erreur QR');
    }
  };

  return (
    <div data-testid="admin-tables-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-heading text-2xl font-bold text-[#2A2A28]">Tables & QR Codes</h1>
        <Button onClick={() => setShowForm(true)} className="rounded-xl bg-[#5B6B3F] hover:bg-[#4A5832] text-white" data-testid="add-table-btn">
          <Plus className="w-4 h-4 mr-1" /> Ajouter
        </Button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {tables.map(table => (
          <div key={table.id} className="bg-white rounded-xl border border-[#EBE8E0] p-5 text-center" data-testid={`table-${table.id}`}>
            <div className="w-16 h-16 rounded-full bg-[#5B6B3F]/10 flex items-center justify-center mx-auto mb-3">
              <span className="font-heading text-2xl font-bold text-[#5B6B3F]">{table.number}</span>
            </div>
            <h3 className="font-medium text-[#2A2A28]">Table {table.number}</h3>
            <p className="text-sm text-[#7A7A75] mb-4">{table.seats} places</p>
            <div className="flex gap-2 justify-center">
              <Button size="sm" variant="outline" className="rounded-lg" onClick={() => showQR(table)} data-testid={`qr-btn-${table.id}`}>
                <QrCode className="w-3.5 h-3.5 mr-1" /> QR Code
              </Button>
              <Button size="sm" variant="outline" className="rounded-lg border-[#8C3A3A]/20 text-[#8C3A3A]" onClick={() => del(table.id)} data-testid={`delete-table-${table.id}`}>
                <Trash2 className="w-3.5 h-3.5" />
              </Button>
            </div>
          </div>
        ))}
      </div>

      {tables.length === 0 && <p className="text-center text-[#7A7A75] py-8">Aucune table. Ajoutez-en une !</p>}

      {/* Add Table Dialog */}
      <Dialog open={showForm} onOpenChange={setShowForm}>
        <DialogContent>
          <DialogHeader><DialogTitle className="font-heading">Nouvelle table</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div><Label className="text-sm">Numero</Label><Input type="number" className="mt-1 rounded-xl border-[#EBE8E0]" value={form.number} onChange={e => setForm({...form, number: e.target.value})} data-testid="table-form-number" /></div>
            <div><Label className="text-sm">Nombre de places</Label><Input type="number" className="mt-1 rounded-xl border-[#EBE8E0]" value={form.seats} onChange={e => setForm({...form, seats: e.target.value})} data-testid="table-form-seats" /></div>
            <Button onClick={create} className="w-full rounded-xl bg-[#5B6B3F] hover:bg-[#4A5832] text-white" data-testid="table-form-save">Creer la table</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* QR Code Dialog */}
      <Dialog open={!!qrDialog} onOpenChange={() => setQrDialog(null)}>
        <DialogContent className="text-center">
          <DialogHeader><DialogTitle className="font-heading">QR Code - Table {qrDialog?.table_number}</DialogTitle></DialogHeader>
          {qrDialog && (
            <div className="space-y-4">
              <img src={qrDialog.qr_image_url || qrDialog.qr_code} alt="QR Code" className="mx-auto w-64 h-64" data-testid="qr-code-image" />
              <p className="text-xs text-[#7A7A75] break-all">{qrDialog.url}</p>
              <a href={qrDialog.qr_image_url || qrDialog.qr_code} download={`table-${qrDialog.table_number}-qr.png`}>
                <Button className="rounded-xl bg-[#5B6B3F] hover:bg-[#4A5832] text-white" data-testid="download-qr">
                  <Download className="w-4 h-4 mr-1" /> Telecharger
                </Button>
              </a>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
